import React, { useEffect, useState } from "react";
import "./inventorycontrols.css";

const PaymentApproval = () => {
  const [payments, setPayments] = useState([]);
  const [config, setConfig] = useState(null);
  const [declineReasons, setDeclineReasons] = useState({});
  const [declinedPayments, setDeclinedPayments] = useState([]);
   const [reacceptReasons, setReacceptReasons] = useState({}); 
   const [approvedPayments, setApprovedPayments] = useState([]);

  // Load config
  useEffect(() => {
    const loadConfig = async () => {
      try {
        const res = await fetch("/config.json");
        const cfg = await res.json();
        setConfig(cfg);
      } catch (err) {
        console.error("Error loading config:", err);
      }
    };
    loadConfig();
  }, []);

  // Fetch payments
  useEffect(() => {
    if (!config) return;

    const fetchPayments = async () => {
      try {
        const res = await fetch(`${config.BASE_URL}${config.GET_PAID_PRODUCTS}`, {
          method: "POST",
          credentials: "include",
        });
        const data = await res.json();
        if (data.status) {
          setPayments(data.orders || []);
        }
      } catch (err) {
        console.error("Error fetching payments:", err);
      }
    };

    fetchPayments();
  }, [config]);

  // Handle accept/decline
  const handleAction = async (payment, action) => {
    if (!config) return;

    try {
      const body = {
        payment_id: payment.payment_id,   
        product_id: payment.product_id,   
        quantity: payment.user_quantity,  
        action,
      };

      if (action === "decline") {
        body.decline_reason = declineReasons[payment.payment_id + "_" + payment.product_id] || "";
        if (!body.decline_reason.trim()) {
          alert("Please provide a reason for declining.");
          return;
        }
      }

      const res = await fetch(`${config.BASE_URL}${config.UPDATE_INVENTORY}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(body),
      });

      const data = await res.json();
      if (data.success) {
        setPayments((prev) =>
          prev.filter(
            (p) =>
              !(p.payment_id === payment.payment_id && p.product_id === payment.product_id)
          )
        );
      } else {
        alert("Action failed: " + data.message);
      }
    } catch (err) {
      console.error("Action error:", err);
    }
  };

  // Fetch declined payments
useEffect(() => {
  if (!config) return;

  const fetchDeclinedPayments = async () => {
    try {
      const res = await fetch(`${config.BASE_URL}${config.GET_DECLINED_PRODUCTS}`, {
        method: "POST",
        credentials: "include",
      });
      const data = await res.json();
      if (data.status) {
        setDeclinedPayments(data.orders || []);
      }
    } catch (err) {
      console.error("Error fetching declined payments:", err);
    }
  };

  fetchDeclinedPayments();
}, [config]);

useEffect(() => {
    if (!config) return;
    const fetchApproved = async () => {
      try {
        const res = await fetch(`${config.BASE_URL}${config.GET_APPROVED_PRODUCTS}`, {
          method: "POST",
          credentials: "include",
        });
        const data = await res.json();
        if (data.status) setApprovedPayments(data.orders || []);
      } catch (err) {
        console.error("Error fetching approved:", err);
      }
    };
    fetchApproved();
  }, [config]);

// Handle accept/decline/reaccept/close
const handleAction1 = async (payment, action) => {
  if (!config) return;

  try {
    let body = {
      action,
      user_id: payment.user_id,
      product_id: payment.product_id,
    };

    // Decline action (on pending orders)
    if (action === "decline") {
      body.decline_reason =
        declineReasons[payment.payment_id + "_" + payment.product_id] || "";
      if (!body.decline_reason.trim()) {
        alert("Please provide a reason for declining.");
        return;
      }
    }

    // Reaccept action (on declined orders)
    if (action === "reaccept") {
      body.reason =
        reacceptReasons[payment.payment_id + "_" + payment.product_id] || "";
      if (!body.reason.trim()) {
        alert("Please provide a reaccept reason.");
        return;
      }
    }

    const res = await fetch(
      `${config.BASE_URL}${config.UPDATE_DECLINE_ORDERS}`, 
      {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        credentials: "include",
        body: new URLSearchParams(body).toString(),
      }
    );

    const data = await res.json();

    if (data.status) {
      if (action === "reaccept" || action === "close") {
        setDeclinedPayments((prev) =>
          prev.filter(
            (p) =>
              !(
                p.user_id === payment.user_id &&
                p.product_id === payment.product_id
              )
          )
        );
      } else {
        setPayments((prev) =>
          prev.filter(
            (p) =>
              !(
                p.payment_id === payment.payment_id &&
                p.product_id === payment.product_id
              )
          )
        );
      }
    } else {
      alert("Action failed: " + data.message);
    }
  } catch (err) {
    console.error("Action error:", err);
  }
};



  return (
    <div className="payment-approval-container">
      <h2>Payment Approvals</h2>
      <table className="payment-approval-table">
        <thead>
          <tr>
            <th>User Name</th>
            <th>Mobile Number</th>
            <th>Email</th>
            <th>Address</th>
            <th>Order ID</th>
            <th>Payment ID</th>
            <th>Product ID</th>
            <th>User Quantity</th>
            <th>Product Quantity</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {payments.length > 0 ? (
            payments.map((payment, idx) => (
              <tr key={idx}>
                <td>{payment.fullname}</td>
                <td>{payment.mobilenumber}</td>
                <td>{payment.mail}</td>
                <td>{payment.address1}</td>
                <td>{payment.order_id}</td>
                <td>{payment.payment_id}</td>
                <td>{payment.product_id}</td>
                <td>{payment.user_quantity}</td>
                <td>{payment.product_quantity}</td>
                <td>
                  <button
                    className="accept-btn"
                    onClick={() => handleAction(payment, "accept")}
                  >
                    Accept
                  </button>
                  <div className="decline-section">
                    <input
                      type="text"
                      placeholder="Reason"
                      value={
                        declineReasons[payment.payment_id + "_" + payment.product_id] || ""
                      }
                      onChange={(e) =>
                        setDeclineReasons({
                          ...declineReasons,
                          [payment.payment_id + "_" + payment.product_id]: e.target.value,
                        })
                      }
                    />
                    <button
                      className="decline-btn"
                      onClick={() => handleAction(payment, "decline")}
                    >
                      Decline
                    </button>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="10">No orders found.</td>
            </tr>
          )}
        </tbody>
      </table>

      <h2>Declined Approvals</h2>
<table className="payment-approval-table">
  <thead>
    <tr>
      <th>User Name</th>
      <th>Mobile Number</th>
      <th>Email</th>
      <th>Address</th>
      <th>Order ID</th>
      <th>Payment ID</th>
      <th>Product ID</th>
      <th>User Quantity</th>
      <th>Product Quantity</th>
      <th>Decline Reason</th>
      <th>Reaccept Reason</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    {declinedPayments.length > 0 ? (
      declinedPayments.map((payment, idx) => (
        <tr key={idx}>
          <td>{payment.fullname}</td>
          <td>{payment.mobilenumber}</td>
          <td>{payment.mail}</td>
          <td>{payment.address1}</td>
          <td>{payment.order_id}</td>
          <td>{payment.payment_id}</td>
          <td>{payment.product_id}</td>
          <td>{payment.user_quantity}</td>
          <td>{payment.product_quantity}</td>
          <td>{payment.decline_reason}</td>
          <td>
            <input
              type="text"
              placeholder="Reaccept reason"
              value={reacceptReasons[payment.payment_id + "_" + payment.product_id] || ""}
              onChange={(e) =>
                setReacceptReasons({
                  ...reacceptReasons,
                  [payment.payment_id + "_" + payment.product_id]: e.target.value,
                })
              }
            />
          </td>
          <td>
            <button
              className="accept-btn"
              onClick={() => handleAction1(payment, "reaccept")}
            >
              Reaccept
            </button>
            <button
              className="decline-btn"
              onClick={() => handleAction1(payment, "close_ticket")}
            >
              Close Ticket
            </button>
          </td>
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan="12">No declined approvals found.</td>
      </tr>
    )}
  </tbody>
</table>

     <h2>Approved Orders</h2>
      <table className="payment-approval-table">
        <thead>
          <tr>
            <th>User Name</th>
            <th>Mobile Number</th>
            <th>Email</th>
            <th>Address</th>
            <th>Order ID</th>
            <th>Payment ID</th>
            <th>Product ID</th>
            <th>User Quantity</th>
            <th>Product Quantity</th>
          </tr>
        </thead>
        <tbody>
          {approvedPayments.length > 0 ? (
            approvedPayments.map((payment, idx) => (
              <tr key={idx}>
                <td>{payment.fullname}</td>
                <td>{payment.mobilenumber}</td>
                <td>{payment.mail}</td>
                <td>{payment.address1}</td>
                <td>{payment.order_id}</td>
                <td>{payment.payment_id}</td>
                <td>{payment.product_id}</td>
                <td>{payment.user_quantity}</td>
                <td>{payment.product_quantity}</td>
              </tr>
            ))
          ) : (
            <tr><td colSpan="9">No approved orders found.</td></tr>
          )}
        </tbody>
      </table>

    </div>
  );
};

export default PaymentApproval;
